import { render } from "./AnalyticsPage.vue?vue&type=template&id=c4b7b76e&ts=true"
import script from "./AnalyticsPage.vue?vue&type=script&lang=ts"
export * from "./AnalyticsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__